import { render, staticRenderFns } from "./OnboardingWizardWrapper.vue?vue&type=template&id=056ce088&scoped=true"
import script from "./OnboardingWizardWrapper.vue?vue&type=script&lang=js"
export * from "./OnboardingWizardWrapper.vue?vue&type=script&lang=js"
import style0 from "./OnboardingWizardWrapper.vue?vue&type=style&index=0&id=056ce088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ce088",
  null
  
)

export default component.exports